import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/traceway-test-crash")({
  head: () => ({
    meta: [
      { title: "Not for indexing | HostRight" },
      { name: "robots", content: "noindex, nofollow" },
      { name: "googlebot", content: "noindex, nofollow" },
    ],
  }),
  component: TracewayTestCrash,
});

function TracewayTestCrash() {
  if (typeof window !== "undefined") {
    throw new Error("Traceway test crash: intentional verification error");
  }

  return null;
}
